const log = require('log').create('get started', 'common') // eslint-disable-line

/**
 * list of checklist items that are used in both the free and pro checklists.
 * this is a keyed object so we can reference them as common.item_id in the other
 * checklists. the key is add as an id below.
 */

const common = {

    verify_email: {
        disable_cache: true,
        applicable() {
            if (this.user.get('opened_verify_modal')) return false
            return this.user.has('flags.email_verified')
        },
        completed() {
            return this.user.get('flags.email_verified')
        },
        onClick(e) {
            e.preventDefault()
            require.ensure([], () => {
                const VerifyModal = require('module/verify/modal')
                this.verify_modal = new VerifyModal({
                    user: this.user,
                })
                this.user.set('opened_verify_modal', true)
            }, 'verify-email')
        },
    },

    add_custom_domain: {
        completed() {
            if (! this.user.hasFeature('upgrade')) return false
            const domain = this.user.get('domain')
            return !! domain
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('domain')
        },
    },

    link_social_sites: {
        completed() {
            return this.user.hasFeature('social_links')
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('socialbios')
        },
    },

    add_testimonials_or_contact_me: {
        completed() {
            return (
                this.user.hasFeature('testimonials')
                || this.user.hasFeature('contact_me')
            )
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('addon')
        },
    },

    add_portfolio_or_video: {
        completed() {
            return (
                this.user.hasFeature('portfolio')
                || this.user.hasFeature('video')
            )
        },
        onClick(e) {
            e.preventDefault()
            this.showSection('addon')
        },
    },

}

// add id property
Object.keys(common).forEach(key => {
    common[key].id = key
})

module.exports = common
